import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-accordion',
  imports: [IconComponent],
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent {
  @Input() id = 0;
  @Input() headerTitle = '';
  @Input() showActionButtons = false;
  @Input() isPanelActive = false;

  @Output() panelStateChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() delete: EventEmitter<number> = new EventEmitter<number>();
  @Output() edit: EventEmitter<number> = new EventEmitter<number>();
  @Output() hide: EventEmitter<number> = new EventEmitter<number>();

  togglePanelActive() {
    this.isPanelActive = !this.isPanelActive;
    this.panelStateChanged.emit(this.isPanelActive);
  }
}
